import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AutenticacaoRequest, AutenticacaoResponse } from '../models/autenticacao';
import { publishReplay, share } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AutenticaoService {

  private http: HttpClient;
  public accessTokenExiste : BehaviorSubject<boolean>;

  constructor(private handler: HttpBackend) {
      this.http = new HttpClient(handler);
      this.accessTokenExiste = new BehaviorSubject<boolean>(false)
  }

  public getAccessByClient(): Observable<any> {
    return this.http.post(`${environment.securityIamBasePath}/client-identities/identify`, null, {
      headers: { 'Content-Type': 'application/json' },
      params: { clientId: environment.certificateAuthentication }
    });
  }

  login(autenticacaoRequest: AutenticacaoRequest, clientAccessToken : string): Observable<any> {
    return this.http.post(environment.url + '/lgpd/sintetico/v1/login', autenticacaoRequest, {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${clientAccessToken}` }
    });
  }

}
